// assets/anchor-links.js
(() => {
  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const MQ = window.matchMedia && window.matchMedia('(max-width: 749px)');
  const DESKTOP_ID = 'subscription';
  const MOBILE_ID = 'subscription-mobile';
  const PENDING_KEY = 'oval_pending_anchor';

  function isMobile() {
    return MQ && MQ.matches;
  }

  function routedId() {
    if (isMobile() && document.getElementById(MOBILE_ID)) return MOBILE_ID;
    return DESKTOP_ID;
  }

  function getHeaderOffset() {
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');

    const h = header ? Math.ceil(header.getBoundingClientRect().height) : 0;

    // 20px on mobile, 40px on desktop
    const buffer = isMobile() ? 50 : 70;

    return (h || 120) + buffer;
  }

  function clearHash() {
    if (!location.hash) return;
    history.replaceState(null, '', location.pathname + location.search);
  }

  function smoothScrollToTop() {
    if (prefersReduced) window.scrollTo(0, 0);
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function isHeaderLogoLink(linkEl) {
    if (!linkEl) return false;
    return (
      linkEl.classList.contains('header__heading-link') ||
      !!linkEl.closest('.header__heading')
    );
  }

  function smoothScrollTo(target) {
    if (!target) return;

    const headerOffset = getHeaderOffset() || 80;
    const y = window.pageYOffset + target.getBoundingClientRect().top - headerOffset;

    if (prefersReduced) window.scrollTo(0, y);
    else window.scrollTo({ top: y, behavior: 'smooth' });

    // keep URL clean
    setTimeout(clearHash, 0);
  }

  function tryScrollById(id) {
    if (!id) return false;
    const el = document.getElementById(id);
    if (!el) return false;
    smoothScrollTo(el);
    return true;
  }

  function isHomePath(pathname) {
    // Shopify home can be "/" or "" depending on parsing
    return pathname === '/' || pathname === '';
  }

  function shouldRewriteHref(href) {
    if (!href) return false;
    return href.indexOf('#' + DESKTOP_ID) !== -1 || href.indexOf('#' + MOBILE_ID) !== -1;
  }

  function rewriteHrefString(href, toId) {
    return href.replace(/#subscription(-mobile)?(\b|$)/, '#' + toId);
  }

  function rewriteLinks(root) {
    const toId = routedId();
    const scope = root && root.querySelectorAll ? root : document;

    const links = scope.querySelectorAll('a[href]');
    for (let i = 0; i < links.length; i++) {
      const a = links[i];
      const href = a.getAttribute('href');
      if (!shouldRewriteHref(href)) continue;

      if (!a.dataset.subHrefOrig) a.dataset.subHrefOrig = href;

      const orig = a.dataset.subHrefOrig;
      a.setAttribute('href', rewriteHrefString(orig, toId));
    }
  }

    function handleAnchorClick(e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    if (link.hasAttribute('data-no-smooth')) return;

    const href = link.getAttribute('href');
    if (!href) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (err) {
      return;
    }

    // only same origin
    if (url.origin !== window.location.origin) return;

    const samePath = url.pathname === window.location.pathname;

    // Logo on homepage: prevent reload and scroll to top
    // (only triggers when the link points to the current page, so it won't affect other pages)
    if (!url.hash && samePath && isHeaderLogoLink(link)) {
      e.preventDefault();
      smoothScrollToTop();
      return;
    }

    // existing anchor behavior below
    if (!url.hash || url.hash.length < 2) return;

    let targetId = decodeURIComponent(url.hash.slice(1));

    // If they clicked either subscription anchor, route to the right one for this viewport
    if (targetId === DESKTOP_ID || targetId === MOBILE_ID) {
      targetId = routedId();
    }

    // Same page: intercept + scroll (NO hash in URL)
    if (samePath) {
      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();
      smoothScrollTo(target);
      return;
    }

    // Cross-page:
    // - store where to scroll
    // - navigate to homepage WITHOUT hash
    if (targetId === DESKTOP_ID || targetId === MOBILE_ID || targetId === routedId()) {
      e.preventDefault();
      sessionStorage.setItem(PENDING_KEY, targetId);
      window.location.assign('/');
      return;
    }

    // otherwise, let normal navigation happen
  }

  // Click handling
  document.addEventListener('click', handleAnchorClick);

  // Initial rewrite + keep rewrite working as sections change
  function init() {
    rewriteLinks(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  if (MQ && MQ.addEventListener) {
    MQ.addEventListener('change', () => rewriteLinks(document));
  } else {
    window.addEventListener('resize', () => rewriteLinks(document));
  }

  const mo = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      for (let j = 0; j < m.addedNodes.length; j++) {
        const n = m.addedNodes[j];
        if (n && n.nodeType === 1) rewriteLinks(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // On load:
  // 1) If we came here from another page (cart, PDP) with a pending anchor, scroll to it.
  // 2) If someone landed with a hash anyway, scroll then remove hash.
  window.addEventListener('load', () => {
    const pending = sessionStorage.getItem(PENDING_KEY);
    if (pending) {
      sessionStorage.removeItem(PENDING_KEY);

      // If pending is subscription, re-resolve for this viewport (mobile/desktop)
      const want = (pending === DESKTOP_ID || pending === MOBILE_ID) ? routedId() : pending;

      setTimeout(() => {
        tryScrollById(want);
        clearHash();
      }, 0);

      return;
    }

    if (location.hash.length > 1) {
      const id = decodeURIComponent(location.hash.slice(1));
      setTimeout(() => {
        tryScrollById(id);
        clearHash();
      }, 0);
    }
  });
})();